import { STORAGE_KEYS } from '../../tokens/constants';
import type { SsoConfig } from '../types';

export interface ResolvedStorageKeys {
  accessTokenKey: string;
  idTokenKey: string;
  refreshTokenKey: string;
}

export const resolveStorageKeys = (config: SsoConfig): ResolvedStorageKeys => ({
  accessTokenKey: config.accessTokenKey ?? STORAGE_KEYS.ACCESS_TOKEN,
  idTokenKey: config.idTokenKey ?? STORAGE_KEYS.ID_TOKEN,
  refreshTokenKey: config.refreshTokenKey ?? STORAGE_KEYS.REFRESH_TOKEN,
});
